import GDPR from 'components/GDPR'
import ChatTakeover from 'components/header/ChatTakeover'
import Conversation from 'components/header/Conversation'
import GreetingMessage from 'components/header/GreetingMessage'
import WelcomeMessage from 'components/header/WelcomeMessage'
import React from 'react'

export const HEADER_STATES = {
  GREETING: 'GREETING',
  CHAT_TAKEOVER: 'CHAT_TAKEOVER',
  CONVERSATION: 'CONVERSATION',
  GDPR: 'GDPR',
  WELCOME_MESSAGE: 'WELCOME_MESSAGE'
}

export const HEADER_COMPONENTS = {
  [HEADER_STATES.WELCOME_MESSAGE]: props => <WelcomeMessage {...props } />,
  [HEADER_STATES.GREETING]: props => <GreetingMessage {...props } />,
  [HEADER_STATES.CONVERSATION]: props => <Conversation {...props} />,
  [HEADER_STATES.GDPR]: props => <GDPR {...props} />,
  [HEADER_STATES.CHAT_TAKEOVER]: props => <ChatTakeover {...props} />
}
